import styled from 'styled-components'
import { PageSection } from 'ui/components/Page'

const WrappedPageSection = styled(PageSection)`
  margin-bottom: 90px;
  position: relative;
`

const PoweredContainer = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;

  span {
    font-size: 13px;
    color: #868686;
  }
`

export const s = {
  WrappedPageSection,
  PoweredContainer
}
